import React from 'react';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { D as DataListActions } from './DataListActions-BbpSgSoY.js';
import { u as useResponsiveSizing } from './useResponsiveSizing-Di5cJapL.js';

var styles = {"bulkActions":"v-GrdlFpBLk-"};

// This component is meant to capture the props of the DataList.BulkActions
function DataListBulkActions(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_) {
    return null;
}
function InternalDataListBulkActions() {
    const { bulkActionsComponent } = useDataListContext();
    if (!bulkActionsComponent)
        return null;
    const { children } = bulkActionsComponent.props;
    const { sm } = useResponsiveSizing();
    // Collapse all actions under "More actions" when breakpoint is smaller than sm
    const itemsToExpose = sm ? 3 : 0;
    return (React.createElement("div", { className: styles.bulkActions },
        React.createElement(DataListActions, { itemsToExpose: itemsToExpose }, children)));
}

export { DataListBulkActions as D, InternalDataListBulkActions as I };
